import { useEffect } from 'react';
import '../../utils/assertions.es.js';
import { noop } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const useMountEffect = (effect, cleanup = noop) => useEffect(() => {
  effect();
  return cleanup;
}, []);

export { useMountEffect as default, useMountEffect };
//# sourceMappingURL=useMountEffect.es.js.map
